<!-- 简单视图定制界面 -->
<template>
<div>
    <el-dialog :title="title" :close-on-click-modal="false"  :fullscreen="isMinScreen" 
        :visible.sync="visible" width="800px" append-to-body
    >
        <div>
            <div>
                <span>视图名：</span>
                <el-autocomplete v-model="selectedViewName" size="mini"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入内容"
                    @select="viewChange" 
                    suffix-icon="el-icon-arrow-down"
                ></el-autocomplete>
                <span style="display:inline-block; margin-left:14px;">设为常用视图：</span>
                <el-switch v-model="hasUsually" :active-value="1" :inactive-value="0"></el-switch>
            </div>
            
            <el-row>
                <el-col :xs="24" :sm="12">
                    <div>
                        <span class="column-title">字段</span>
                        <el-checkbox style="margin-left:20px;" @change="(v)=> viewColumns.forEach(c => c.checked = v)">全选</el-checkbox>
                    </div>
                    <el-scrollbar class="vlist">
                        <template>
                            <draggable v-model="viewColumns">
                                <transition-group>
                                    <div v-for="col in viewColumns" :key="col.field" 
                                        :class="[col.checked?'active': '', 'col-item']"
                                        @click = "(e)=> setChecked(e, col)"
                                    >
                                        <el-checkbox v-model="col.checked">{{col.title + (col.alias ? "("+col.alias+")": "")}}</el-checkbox>
                                        <i class="el-icon-edit" v-on:click="(e) => editCol(e, col)"></i>
                                    </div>
                                </transition-group>
                            </draggable>
                        </template>
                    </el-scrollbar>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <div>
                        <span class="column-title">查询条件</span>
                        <el-checkbox style="margin-left:20px;" @change="(v)=> viewQueries.forEach(c => c.checked = v)">全选</el-checkbox>
                    </div>
                    <el-scrollbar class="vlist">
                        <template>
                            <draggable v-model="viewQueries">
                                <transition-group>
                                    <div v-for="col in viewQueries" :key="col.field" 
                                        :class="[col.checked?'active': '', 'col-item']"
                                        @click = "(e)=> setChecked(e, col)"
                                    >
                                        <el-checkbox v-model="col.checked">{{col.title + (col.alias ? "("+col.alias+")": "")}}</el-checkbox>
                                        <i class="el-icon-edit" v-on:click="(e)=>editQuery(e, col)"></i>
                                    </div>
                                </transition-group>
                            </draggable>
                        </template>
                    </el-scrollbar>
                </el-col>
            </el-row>
            <el-alert type="error"
                title="注：拖动字段可以进行排序"
            >
            </el-alert>
            <div style="text-align:center; padding: 15px;">
                <el-tooltip effect="dark" content="点击关闭" placement="top">
                    <el-button size="mini" icon="el-icon-circle-close" @click="()=> visible=false">取消</el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="更新当前选中的视图设置" placement="top">
                    <el-button type="primary" icon="el-icon-circle-check" plain size="mini" @click="save(1)">更新</el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="将当前视图保存为一个新的视图" placement="top">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" size="mini" @click="save(2)">创建</el-button>
                </el-tooltip>
            </div>
        </div>
    </el-dialog>

    <!-- 编辑显示字段的弹窗 -->
    <el-dialog title="编辑字段" :close-on-click-modal="true"  :fullscreen="isMinScreen" 
        :visible.sync="colVisible" width="400px" append-to-body
    >
        <el-form v-if="currColumn" ref="colForm" :model="currColumn" label-width="120px" size="mini">
            <el-form-item :label="msg('编辑的字段')+':'" label-width="120px">
                <el-input v-model="currColumn.title" readonly="readonly" inert></el-input>
            </el-form-item>
            <el-form-item :label="msg('自定义显示名称')+':'" label-width="120px">
                <el-input v-model="currColumn.alias"></el-input>
            </el-form-item>
            <el-form-item :label="msg('列宽')+':'">
                <el-input v-model="currColumn.width"></el-input>
            </el-form-item>
            <el-form-item :label="msg('是否启用排序')+':'" label-width="120px">
                <el-switch
                    v-model="currColumn.sortable"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
            </el-form-item>
            <el-form-item :label="msg('列筛选类型')+':'" label-width="120px">
                <el-radio-group v-model="currColumn.filterType">
                    <el-radio v-for="item in dicts.filterTypes" :label="item.value" :key="item.value">{{item.label}}</el-radio><br/>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="currColumn.filterType=='type'"  
                :label="msg('待筛选内容')+':'" label-width="120px"
            >
                <el-select v-model="currColumn.filterOptionKey" size="mini" placeholder="请选择" >
                    <el-option v-for="d in filterOptionTypes" 
                        :key="d.key" :label="d.label" :value="d.key"></el-option>
                </el-select> 
            </el-form-item>
            <div v-if="currColumn.filterOptionKey" style="padding-left:15px;">
                <el-tag style="margin-right:8px;margin-bottom:8px;" v-for="opt in getOptions(currColumn.filterOptionKey)" type="danger" :key="opt.value">{{opt.label}}</el-tag>
            </div>
            <div style="text-align:center;">
                <el-button type="warning" icon="el-icon-magic-stick" @click="()=> {currColumn.filterType = null; currColumn.filterOptionKey=null}" plain size="mini">清空筛选条件</el-button>
                <el-button type="primary" icon="el-icon-circle-check" @click="()=> colVisible = false" plain size="mini">确定</el-button>
            </div>
        </el-form>
    </el-dialog>

    <!-- 编辑查询字段的弹窗 -->
    <el-dialog title="编辑查询字段" :close-on-click-modal="true"  :fullscreen="isMinScreen" 
        :visible.sync="queryVisible" width="400px" append-to-body
    >
        <el-form v-if="currQuery" ref="queryForm" :model="currQuery" label-width="120px" size="mini">
            <el-form-item :label="msg('字段名')+':'" >
                <el-input v-model="currQuery.title" readonly="readonly"></el-input>
            </el-form-item>
            <el-form-item :label="msg('自定义显示名称')+':'" >
                <el-input v-model="currQuery.alias"></el-input>
            </el-form-item>
            <el-form-item :label="msg('提示语')+':'">
                <el-input v-model="currQuery.placeholder"></el-input>
            </el-form-item>
            <el-form-item :label="msg('查询类型')+':'" >
                <span>{{currQuery.type}}</span>
            </el-form-item>
            <el-form-item v-if="currQuery.type == 'input'" :label="msg('筛选方式')+':'" >
                <el-select v-model="currQuery.operator" size="mini" placeholder="请选择" >
                    <el-option v-for="d in operators" 
                        :key="d.value" :label="d.label" :value="d.value"></el-option>
                </el-select> 
            </el-form-item>
            <div v-if="currQuery.type == 'selector' || currQuery.type == 'selectors'" style="padding-left:15px;">
                <el-tag style="margin-right:8px; margin-bottom:8px;" v-for="(opt, idx) in getDicts(currQuery.operator)" type="danger" :key="idx">{{opt.label}}</el-tag>
            </div>
            <el-form-item :label="msg('默认值')+':'">
                <el-input v-if="currQuery.type == 'input' && currQuery.operator != 3" v-model="currQuery.defaultValue"  clearable></el-input>
                <el-select v-if="currQuery.type == 'input' && currQuery.operator == 3" v-model="currQuery.defaultValues" 
                    multiple filterable allow-create default-first-option
                    size="mini" :placeholder="msg('按确认键输入下一个值')">
                </el-select>
                <el-select v-if="currQuery.type === 'selector'" v-model="currQuery.defaultValue" @change="changeSelect"  size="mini" placeholder="请选择" clearable>
                    <el-option v-for="(d, idx) in getDicts(currQuery.operator)"   
                        :key="idx" :label="d.label" :value="d.value"></el-option>
                </el-select> 
                <el-select v-if="currQuery.type === 'selectors'" v-model="currQuery.defaultValues" size="mini" placeholder="请选择" multiple clearable>
                    <el-option v-for="(d, idx) in getDicts(currQuery.operator)" 
                        :key="idx" :label="d.label" :value="d.value"></el-option>
                </el-select> 
                <el-select v-if="currQuery.type == 'daterange' || currQuery.type == 'datetimerange'" size="mini" placeholder="请选择" v-model="currQuery.defaultValue" clearable>
                    <el-option v-for="(d, idx) in dicts.dateRanges" 
                        :key="idx" :label="d.label" :value="d.value"></el-option>
                </el-select>  
            </el-form-item>
            <div style="text-align:center;">
                <el-button type="primary" icon="el-icon-circle-check" @click="()=> queryVisible = false" plain size="mini">确定</el-button>
            </div>
        </el-form>
    </el-dialog>
</div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
    name: "ViewSettingDialog",
    components:{
        draggable: draggable,
    },
    data() {
        return {
            title: "视图设置",
            visible: false,     //是否显示
            viewOptions: [], //{id: name:}, //待选择的视图名称列表
            selectedViewName: null, //已选中的视图名称
            currView: null,    //当前选中的视图对象
            type: "1",  //视图类型，1-订单管理视图，目前只有订单管理,
            hasUsually: false, //是否常用视图
            views: null,
            columns: null,  //传进来的原生定义的字段名 {field,title}
            queries: null,  //传进来的原生定义的查询条件{field, title, type}
            viewColumns: null,  // field, alias, title, width, filterType, filterOptionKey, sortable,
            viewQueries: null,  // field, alias, title, placeholder, type, operator, defaultValue, defaultValues

            colVisible: false,  //编辑字段弹窗是否显示
            currColumn: null,   //当前编辑的字段
            filterOptionTypes: null, //{label, key}

            queryVisible: false, //编辑查询条件是否显示
            currQuery: null,   //当前编辑的查询条件
            queryTypes: [
                {label: "文本输入", value: "input"},
                {label: "下拉选择", value: "selector"},
                {label: "下拉多选", value: "selectors"},
                {label: "日期选择", value: "dateRange"},
                {label: "日期时间选择", value: "datetimeRange"},
            ],
            operators: [
                {label: "等于", value: 0},
                {label: "批量输入", value: 3},
                {label: "左包含", value: 1},
                {label: "包含", value: 2},
            ]
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
    },
    methods: {
        /**
         * @param type 1:订单管理，目前只有订单管理有这个类型
         * @param view  当前页面所选中的视图，当前页面没有视图，这为空
         * @param columns 当前页面的字段 [{field, title}]
         * @param queries 当前页面的所有查询条件   {field: "code", type: "input", title: "订单编号"},
         * @param filterOptionTypes: 当filterType == 'type'的时候, 这个提供筛选, 
         *  意思就是table的列级filter的筛选类型是type,需要指定待筛选的type列表
         */
        showDialog(type, view, columns, queries, filterOptionTypes) {
            this.type = type;
            this.currView = view;
            this.columns = columns;
            this.queries = queries;
            this.filterOptionTypes = filterOptionTypes;

            if(this.views == null){
                this.loadViewByType(type);
            }
            
            this.buildCurrentView(view);
            this.buildViewColumns();
            this.buildViewQueries();
            this.selectedViewName = view?.name || "";
            this.visible = true;

        },
        //加载指定类型的视图
        async loadViewByType(type){
            // load views
            // build viewOptions
            // init selectedViewName
            // parse columns
            // parse queries
            
            try{
                let result = await this.$axios.get(this.$kit.api.user.setting.view.loadViewByType+"?type="+type);
                if(result.status){
                    let views = result.data;
                    if(views && views.length>0){
                        views.forEach(view => {
                            if(view.columns) view.columns = JSON.parse(view.columns);
                            if(view.queries) view.queries = JSON.parse(view.queries);
                        });
                        this.views = views;
                        this.viewOptions = this.views.map(item => {
                            return {
                                id: item.id,
                                value : item.name
                            }
                        });
                    }
                }
            }catch(err){
                console.log(err);
            }
        },
        buildCurrentView(){
            if(this.view){
                this.selectedViewName = this.view.name;
                this.hasUsualy = this.view.hasUsualy;
            }else{
                this.selectedViewName = "";
                this.hasUsually = false;
            }
        },
        //构建显示的列
        buildViewColumns(){
            let initColumns = this.columns.map(item => {
                return {
                    field: item.field,
                    title: item.title,
                    alias: null,
                    width: '100',
                    filterType: null,
                    filterOptionKey: null, 
                    sortable: false,
                    checked: false
                }
            });

            //排序, 初始化columns
            let columns = initColumns;
            if(this.currView && this.currView.columns){
                this.currView.columns.forEach(col => {
                    let colIndex = columns.findIndex(c => c.field == col.field);
                    // console.log(colIndex, col, columns, this.columns);
                    let item = columns[colIndex];
                    
                    item.checked = true;
                    item.alias=col.alias;
                    item.width= col.width;
                    item.filterType= col.filterType;
                    item.filterOptionKey= col.filterOptionKey;
                    item.sortable= col.sortable || false;

                    let index = col.index;
                    if(index !== "" && index !== null){
                        if(colIndex !== index){
                            columns.splice(colIndex, 1);
                            columns.splice(index, 0, item)
                        }
                    }
                });
            }
            

            this.viewColumns = columns;
        },
        //构建显示的查询条件
        buildViewQueries(){
            let queries = this.queries.map(item => {
                return {
                    field: item.field,
                    alias: null,
                    title: item.title,
                    placeholder: null,
                    type: item.type,
                    operator: item.operator || null,
                    defaultValue: null,
                    defaultValues: [],
                    checked: false
                }
            });

             //排序, 初始化queries
            if(this.currView && this.currView.queries){
                this.currView.queries.forEach(col => {
                    let colIndex = queries.findIndex(c => c.field == col.field);
                    let item = queries[colIndex];

                    let value = col.defaultValue;
                    let values = [];
                    if(value && col.type == "input" && col.operator == 3 || col.type == "selectors"){
                        values = value? value.split(",").map(s => {
                                if(((s*1)+"") != 'NaN'){
                                    return s*1
                                }else{
                                    return s;
                                }
                            }): [];
                        value = null;
                    }

                    item.alias=col.alias;
                    item.placeholder= col.placeholder;
                    item.type= col.type || "input";
                    item.operator= col.operator;
                    item.checked= true;
                    item.defaultValue= value;
                    item.defaultValues= values;

                    let index = col.index;
                    if(index !== "" && index !== null){
                        if(colIndex !== index){
                            queries.splice(colIndex, 1);
                            queries.splice(index, 0, item)
                        }
                    }
                });
            }

            this.viewQueries = queries;
        },
         //搜索
         querySearch(queryString, cb) {
            // var restaurants = this.restaurants;
            // var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;

            // 调用 callback 返回建议列表的数据
            cb(this.viewOptions);
        },
        viewChange(value){
            let view = this.views.find(item => item.id == value.id);
            if(view){
                this.currView = view;
            }else{
                this.currView = null;
            }
            this.buildViewColumns();
            this.buildViewQueries();
        },
        //编辑列
        editCol(e, col){
            if(e.target.closest(".el-icon-edit")){
                e.stopPropagation();
                 // e.stopPropagation();
                this.currColumn = col;
                this.colVisible = true;
            }
           
        },
        //编辑查询条件
        editQuery(e, query){
            if(e.target.closest(".el-icon-edit")){
                e.stopPropagation();
                this.currQuery = query;
                this.queryVisible = true;
            }
        },
        setChecked(e, col){
            if(e.target.closest(".el-checkbox")){
                e.stopPropagation();
            }else{
                col.checked = !col.checked;
            }
        },
        //获取字典
        getOptions(optionKey){
            let option = this.filterOptionTypes.find(item => item.key == optionKey);
            if(!option) return [];
            let options = this.getDicts(option.value);
            // if(optionKey == 'expCompany'){
            //     options = this.expCompanys;
            // }
            // this.$set(selectQuery,'options', options);
            return options;
        },
        //保存数据
        async save(ctrl){
            if(!this.selectedViewName){
                this.$message("请输入/选择视图名");
                return;
            }

            //构建待保存的数据
            let cols = this.viewColumns
                .filter(col => col.checked)
                .map(col => {
                    return {
                        field: col.field,
                        title: col.title,
                        alias: col.alias,
                        width: col.width,
                        filterType: col.filterType,
                        filterOptionKey: col.filterOptionKey,
                        sortable: col.sortable||false,
                        index: this.viewColumns.indexOf(col)
                    }
                    // return (col.field || "")+","
                    //     +(col.title || "")+","
                    //     +(col.alias || "")+","
                    //     +(col.width || "")+","
                    //     +(col.filterType || "")+","
                    //     +(col.filterOptionKey || "")
                    //     +","+(col.sortable||false);
                });
            
            if(!cols || cols.length == 0){
                this.$message("至少选择一个字段");
                return;
            }

            let queries = this.viewQueries
                .filter(q => q.checked)
                .map(q => {
                    let value = null;
                    if(q.type == 'input'){
                        if(q.operator == 3){
                            value = q.defaultValues? q.defaultValues.join(",") : null;
                        }
                    }else if(q.type == 'selectors'){
                        value = q.defaultValues? q.defaultValues.join(",") : null;
                    }else{
                        value = q.defaultValue || (q.defaultValue === 0?0 : null);
                    }

                    return {
                        field: q.field,
                        alias: q.alias,
                        title: q.title,
                        placeholder: q.placeholder,
                        type: q.type,
                        operator: q.operator,
                        defaultValue: value,
                        index: this.viewQueries.indexOf(q)
                    }
                });
            
            console.log(queries);

            if(!queries || queries.length == 0){
                this.$message("至少选择一个查询条件");
                return;
            }

                
            let dto = {
                id: this.currView? this.currView.id:null,
                name: this.selectedViewName,
                hasUsually: this.hasUsually?1:0,
                type: this.type,
                columns: JSON.stringify(cols),
                queries: JSON.stringify(queries),
            };

            try{
                // console.log(dto);
                let result = await this.$axios.post(this.$kit.api.user.setting.view.saveOrUpdate+"?t="+(ctrl==1?"1":"0"), dto);
                this.$message(result.msg);
                if(result.status){

                    if(!this.currView){
                        this.currView = {
                            id: result.data,
                            name: this.selectedViewName,
                            hasUsually: this.hasUsually,
                            type: this.type,
                            columns: cols,
                            queries: queries,
                        }
                    }else{
                        this.currView.id = result.data;
                    }

                    if(this.views == null) {
                        this.views = [];
                    }

                    if(this.views.length == 0){
                        this.views.push(this.currView);
                    }

                }
            }catch(err){
                console.log(err);
                this.$message(err)
            }
           
        },
        changeSelect(v){
            console.log(v);
        }
    }
}

</script>

<style lang="scss" scoped>
.vlist::v-deep(.el-scrollbar__wrap){overflow-x:hidden;}
.vlist {
    height: 350px; 
    overflow-y:hidden;
    border: 1px solid #dcdfe6;
    margin: 8px;
}
.col-item i {
    display:none;
    margin-left: 6px;
}
.col-item{
    padding: 3px 6px;
    cursor: pointer;
}
.col-item.active, .col-item:hover{
    color: #409eff;
    background: rgba(64, 158, 255, .1);
}
.col-item:hover i {
    display: inline-block;
}

.column-title{
    display:inline-block;
    font-size:16px;
    font-weight:bold;
    padding: 15px 0px 0px 15px;
}

</style>